import Parse from "./parse.service";
import { base64ToBlob } from "../utils";

const Account_managers = Parse.Object.extend("Account_managers");
const Contacts = Parse.Object.extend("Contacts");

import { accountAPI, auth, reminderAPI } from "./index";
import dayjs from "dayjs";

export function fetchUser() {
  return Parse.User.current();
}

// Account Managers

export const accountManagers = async () => {
  const query = new Parse.Query(Account_managers);
  const results = await query.find();
  return results;
};

const downloadReport = async (reportBase64String, fileName) => {
  const blob = base64ToBlob(reportBase64String);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

// Monthly Reports
export const downloadMonthlyReport = async (
  accountId,
  startMonth,
  endMonth,
  type = "pdf"
) => {
  const reportBase64String = await Parse.Cloud.run("getMonthlyreport", {
    id: accountId,
    startMonth: startMonth,
    endMonth: { __type: "Date", iso: endMonth?.toISOString() },
    type
  });

  const account = await accountAPI.getAccountById(accountId);
  const accountName = account?.get("name")

  if (!reportBase64String) return null;
  downloadReport(
    reportBase64String,
    `BK - ${accountName} - (${startMonth === "lifetime"
      ? ""
      : dayjs(startMonth).format("MMM DD YYYY") + " - "
    }${dayjs(endMonth).format("MMM DD YYYY")}).${type === "pdf" ? "pdf" : "xlsx"}`
  );

  return "success";
};

export const downloadCollectionReport = async (accountId) => {
  // Fetch Overdue Accounts to send to the report
  // const overdueAccounts = await Parse.Cloud.run("getOverdueAccounts");
  // console.log("overdueAccounts : ",overdueAccounts);

  const overdueAccounts = await reminderAPI.getOverdueAccounts();

  const reportBase64String = await Parse.Cloud.run("getCollectionReport", {
    overdueAccounts: overdueAccounts,
  });
  downloadReport(reportBase64String, `Bahi Khata - Collection Report.pdf`);
  return "success";
};

export const getContacts = async () => {
  try {
    const query = new Parse.Query(Contacts);
    query.equalTo("userId", auth.fetchUser());
    return await query.find();
  } catch (error) {
    throw error;
  }
};
export const checkConnectivity = async () => {
  try {
    const healthResponse = await fetch(Parse.serverURL + "/health");
    if (healthResponse.ok) {
      return await healthResponse.json();
    }
  } catch (error) {
    throw new Error("Technical Error: App isn't available currently");
  }
};
